<div
    class="data-point-bar"
    [ngClass]="{
        'left-aligned': isLeftAligned,
        'center-aligned': !isLeftAligned,
        'large-data-points': dataPoints | cacheValue: isLargeDataPoints
    }"
>
    <div *ngIf="!dataPoints?.length || loading" class="loading-container">
        <lsq-circle-loader></lsq-circle-loader>
    </div>

    <ng-container *ngIf="!!dataPoints?.length">
        <div
            class="data-points-container"
            [ngClass]="{
                row: !(responsiveService.smBelow | async)
            }"
            *ngIf="
                !(
                    isLeftAligned &&
                    (responsiveService.lgBelow | async) &&
                    !(responsiveService.smBelow | async) &&
                    dataPoints.length === 4
                )
            "
        >
            <div
                *ngFor="let dataPoint of dataPoints"
                class="data-point"
                [ngClass]="{
                    'col-lg-6': dataPoints.length === 4 && !(responsiveService.smBelow | async),
                    'col-xl-3': dataPoints.length === 4 && !(responsiveService.smBelow | async),
                    'col-lg-4': dataPoints.length === 3 && !(responsiveService.smBelow | async)
                }"
            >
                <div class="data-point-container">
                    <div class="data-point-label">
                        {{ dataPoint.label }}
                    </div>

                    <div class="data-point-datum">
                        {{ dataPoint.data }}
                        <ng-container *ngIf="dataPoint.exportInformation">
                            <lsq-export-button
                                [request]="dataPoint.exportInformation.request"
                                [service]="dataPoint.exportInformation.service"
                                [reportName]="dataPoint.exportInformation.reportName"
                                [isIcon]="true"
                                [isTransparent]="true"
                            ></lsq-export-button>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="data-points-container left-aligned-medium row"
            *ngIf="
                isLeftAligned &&
                (responsiveService.lgBelow | async) &&
                !(responsiveService.smBelow | async) &&
                dataPoints.length === 4
            "
        >
            <div class="col-6">
                <div class="column-container">
                    <div class="column-content-container">
                        <ng-container *ngFor="let dataPoint of dataPoints; let i = index">
                            <div *ngIf="!(i % 2)" class="data-point">
                                <div class="data-point-container">
                                    <div class="data-point-label">
                                        {{ dataPoint.label }}
                                    </div>

                                    <div class="data-point-datum">
                                        {{ dataPoint.data }}
                                        <ng-container *ngIf="dataPoint.exportInformation">
                                            <lsq-export-button
                                                [request]="dataPoint.exportInformation.request"
                                                [service]="dataPoint.exportInformation.service"
                                                [reportName]="
                                                    dataPoint.exportInformation.reportName
                                                "
                                                [isIcon]="true"
                                                [isTransparent]="true"
                                            ></lsq-export-button>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="col-6">
                <div class="column-container">
                    <div class="column-content-container">
                        <ng-container *ngFor="let dataPoint of dataPoints; let i = index">
                            <div *ngIf="!!(i % 2)" class="data-point">
                                <div class="data-point-container">
                                    <div class="data-point-label">
                                        {{ dataPoint.label }}
                                    </div>

                                    <div class="data-point-datum">
                                        {{ dataPoint.data }}
                                        <ng-container *ngIf="dataPoint.exportInformation">
                                            <lsq-export-button
                                                [request]="dataPoint.exportInformation.request"
                                                [service]="dataPoint.exportInformation.service"
                                                [reportName]="
                                                    dataPoint.exportInformation.reportName
                                                "
                                                [isIcon]="true"
                                                [isTransparent]="true"
                                            ></lsq-export-button>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
